import { Box, styled } from '@mui/material'
import { renderLines } from 'components/Skeletons/helpers'

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  overflow: 'hidden',
}))

export function DataGridSkeleton(props) {
  return <LoadingContainer {...props}>{renderLines({ columnsLength: 5, rowsLength: 11 })}</LoadingContainer>
}
